import React from 'react';
import CouponsAmountBadge from './Lists/components/CuponesAmountBadge';
import clsx from 'clsx';

interface ThemeTab {
    tabId: string | number;
    tabTitle: string;
    newEventsCount?: number | undefined;
}

interface ThemeTabsProps {
    value: number | string;
    handleChange: (newTabId: any) => void;
    tabs: ThemeTab[];
    containerMaxWidth: boolean;
    indicatorStyles?: any;
    rootStyles?: any;
    tabStyles?: any;
}

export function ThemeTabs(props: ThemeTabsProps) {
    const onChange = (tabId: string | number) => () => {
        props.handleChange(tabId);
    };
    return (
        <div className="flex rounded-[12px] bg-[#171A1E] h-[24px] tablet:h-[40px] tablet:w-[493px] desktop:h-[48px] desktop:w-[429px] overflow-hidden items-center justify-between p-[2px] gap-[2px] mx-auto">
            {props.tabs.map(value => (
                <div
                    key={value.tabId}
                    onClick={onChange(value.tabId)}
                    className={clsx(
                        "cursor-pointer flex-1 h-[24px] tablet:h-[36px] flex items-center justify-center text-[14px] font-['Roboto'] leading-[100%] desktop:text-[16px]",
                        props.value === value.tabId
                            ? 'bg-[#ED3D42B2] text-white font-medium rounded-[12px]'
                            : 'bg-[#171A1E] text-[#727374]'
                    )}
                >
                    {value.newEventsCount ? (
                        <CouponsAmountBadge
                            active={props.value === value.tabId}
                            amount={value.newEventsCount}
                        >
                            <h5>{value.tabTitle}</h5>
                        </CouponsAmountBadge>
                    ) : (
                        <h5>{value.tabTitle}</h5>
                    )}
                </div>
            ))}
        </div>
    );
}
